/* eslint-disable no-param-reassign */
import { createEntityAdapter, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getApi } from 'lib/axios';
import { GET_CAR_MODEL_LIST_API } from 'utils/apiConstants';
import { USER_BASE_URL } from 'utils/const';

import { enqueueSnackbar } from '../notificationSlice';

// 型式（車種の後のやつ）
export const fetchCarModel = createAsyncThunk(
  'carModel/fetchCarModel',
  async (id, { dispatch }) => {
    const res = await getApi(`${USER_BASE_URL}${GET_CAR_MODEL_LIST_API}?car_id=${id}`);

    if (res.data?.length === 0) {
      dispatch(
        enqueueSnackbar({
          message: '指定した車種の型式が見つかりません。',
          options: {
            key: new Date().getTime() + Math.random(),
            variant: 'error',
          },
        }),
      );
    }

    return {
      data: res.data,
    };
  },
);

const carModelAdapter = createEntityAdapter();

const carModelSlice = createSlice({
  name: 'carModel',
  initialState: carModelAdapter.getInitialState({
    loading: true,
  }),
  reducers: {
    addTag: carModelAdapter.addOne,
    removeAll: carModelAdapter.removeAll,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCarModel.fulfilled, (state, action) => {
      state.loading = false;
      carModelAdapter.setAll(state, action.payload.data);
    });
  },
});

export const { removeAll: resetCarModel } = carModelSlice.actions;

export const carModelSelector = carModelAdapter.getSelectors((state) => state.carModel);

export default carModelSlice.reducer;
